import styled from "styled-components";

export const Container = styled.div`
  .initialProducts{
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 2rem auto;
      text-transform: uppercase;
      span.left{
         background-color: white;
         padding: 12px 30px;
         border-radius: 20px;
         position: relative;
         z-index: 1;
      }

      span.right{
         background-color: #fbe777;
         padding: 12px 30px;
         border-radius: 20px;
         margin-left: -20px;
         padding-left: 50px;
      }
   }

   @media only screen and (max-width: 768px) {
      .initialProducts{
         flex-direction: column;
         align-items: center;
         justify-content: center;
      }
      
      .initialProducts span.right{
         margin-left: 0px;
         padding: 12px 30px;
         margin-top: 10px;
      }
    }
`;

